var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignMg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "design-mg7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color-Fill-3",
    d: "M-0.000,-0.001 L-0.000,41.999 L16.000,41.999 L16.000,16.000 L42.000,16.000 L42.000,-0.001 L-0.000,-0.001 zM14.000,14.000 L14.000,39.999 L2.000,39.999 L2.000,1.999 L40.000,1.999 L40.000,14.000 L14.000,14.000 zM44.000,44.000 L18.000,44.000 L18.000,60.000 L60.000,60.000 L60.000,18.000 L44.000,18.000 L44.000,44.000 zM20.000,58.000 L20.000,46.000 L46.000,46.000 L46.000,20.000 L58.000,20.000 L58.000,58.000 L20.000,58.000 zM42.000,18.000 L18.000,18.000 L18.000,41.999 L42.000,41.999 L42.000,18.000 zM40.000,20.000 L40.000,39.999 L20.000,39.999 L20.000,20.000 L40.000,20.000 z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignMg7);
export default __webpack_public_path__ + "static/media/design-mg7.6fcf51d1f2b3c257d6e39bd0bc6a41bf.svg";
export { ForwardRef as ReactComponent };